import { VIEW_HEARTBEAT_MS, type ViewHeartbeatRequest } from '@rp/contracts'
import { useEffect } from 'react'
import { z } from 'zod'
import { useReadySession } from '../../session/useSession'

const ACTIVITY_EVENTS = ['keydown', 'pointerdown', 'input'] as const

export const useViewHeartbeat = (itemId: string): void => {
  const { api } = useReadySession()
  useEffect(() => {
    let lastActivityAt = Date.now()
    const noteActivity = () => {
      lastActivityAt = Date.now()
    }
    const report = () => {
      if (document.hidden) return
      const body: ViewHeartbeatRequest = { active: Date.now() - lastActivityAt < VIEW_HEARTBEAT_MS }
      void api.request(z.null(), { method: 'POST', path: `/v1/queue/${itemId}/view`, body }).catch(() => undefined)
    }
    report()
    const id = setInterval(report, VIEW_HEARTBEAT_MS)
    const onVisibilityChange = () => {
      if (!document.hidden) report()
    }
    document.addEventListener('visibilitychange', onVisibilityChange)
    ACTIVITY_EVENTS.forEach((name) => document.addEventListener(name, noteActivity, true))
    return () => {
      clearInterval(id)
      document.removeEventListener('visibilitychange', onVisibilityChange)
      ACTIVITY_EVENTS.forEach((name) => document.removeEventListener(name, noteActivity, true))
    }
  }, [api, itemId])
}
